import React from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Home, Users, User, CreditCard, MessageSquare, LogOut } from 'lucide-react';

const MemberLayout = () => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const navLinks = [
    { to: '/member/dashboard', label: 'Dashboard', icon: Home },
    { to: '/member/directory', label: 'Directory', icon: Users },
    { to: '/member/profile', label: 'Profile', icon: User },
    { to: '/member/card', label: 'Membership Card', icon: CreditCard },
    { to: '/member/feedback', label: 'Feedback', icon: MessageSquare },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <div className="min-h-screen flex bg-background">
      {/* Sidebar */}
      <aside className="w-64 bg-card border-r border-border hidden lg:block">
        <div className="h-full flex flex-col">
          <div className="p-6 border-b border-border">
            <Link to="/" className="flex items-center space-x-2">
              <img 
                src="/logo.webp" 
                alt="Khatri Mahasabha Logo" 
                className="w-12 h-12 object-contain"
              />
              <div>
                <h1 className="font-serif font-bold text-sm text-primary leading-tight">खत्री महासभा</h1>
                <p className="text-[10px] text-muted-foreground">Member Portal</p>
              </div>
            </Link>
          </div>

          <nav className="flex-1 p-4 space-y-2">
            {navLinks.map((link) => {
              const Icon = link.icon;
              return (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`flex items-center space-x-3 px-4 py-3 rounded-lg font-sans transition-colors ${
                    isActive(link.to)
                      ? 'bg-primary text-primary-foreground'
                      : 'hover:bg-muted text-foreground'
                  }`}
                  data-testid={`nav-${link.label.toLowerCase().replace(' ', '-')}`}
                >
                  <Icon size={20} />
                  <span>{link.label}</span>
                </Link>
              );
            })}
          </nav>

          <div className="p-4 border-t border-border">
            <div className="mb-4 p-3 bg-muted rounded-lg">
              <p className="text-sm font-semibold text-foreground">{user?.fullName}</p>
              <p className="text-xs text-muted-foreground">{user?.email}</p>
            </div>
            <Button
              variant="outline"
              className="w-full"
              onClick={handleLogout}
              data-testid="logout-button"
            >
              <LogOut size={16} className="mr-2" />
              Logout
            </Button>
          </div>
        </div>
      </aside>

      {/* Main Content */}
      <div className="flex-1 flex flex-col">
        {/* Top Bar */}
        <header className="bg-card border-b border-border px-6 py-4 lg:hidden">
          <div className="flex items-center justify-between">
            <h1 className="font-serif font-bold text-xl text-primary">Khatri Mahasabha</h1>
            <Button variant="outline" size="sm" onClick={handleLogout}>
              <LogOut size={16} />
            </Button>
          </div>
        </header>

        <main className="flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default MemberLayout;